export default class IntercomHandler {
  constructor(intercom){
    this.config = {};
    this.intercom = intercom;
  }

  setProperties(newProperties){
    this.config = Object.assign({}, this.config, newProperties)
  }

  initIntercom(){
    this.intercom("boot", this.config)
  }
}

export const global = new IntercomHandler(window.Intercom);



// WEBPACK FOOTER //
// ./src/tracking/IntercomHandler.js